<template>
	<div class="addPosition">
		<el-container>
			<el-header class="management_header">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的管理员{{showID}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="addControl()">+新增管理员</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="management_aside">
					<el-menu default-active="2" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoadd()">
							<span class="menuText" slot="title">新增岗位</span>
						</el-menu-item>
						<el-menu-item index="2">
							<span class="menuText" slot="title">查询/修改岗位信息</span>
						</el-menu-item>
						<el-submenu index="3">
							<template slot="title">
								<span class="menuText">查看简历</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" @click="gotolookupresumeByName()">按人名查找</el-menu-item>
								<el-menu-item index="3-2" @click="gotolookupresume()">按时间、岗位查找</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-menu-item index="4" @click="gotorecruitInfoService()">
							<span class="menuText" slot="title">招聘公告维护</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="management_body">
					<addControl v-show="addControlDialog" v-on:addAdmingAccount='addAdmingAccount'></addControl>
					<div class="search_body">
						<div class="search_input">
							<el-input v-model="input" placeholder="请输入您要查询岗位的关键字"></el-input>
							<button class="search_button" @click="searchPosition()"><img
									src="../../image/search.png"></button>
						</div>
					</div>
					<div class="search_res">
						<el-table :data="positionData" class="position_info" v-infinite-scroll="load">
							<el-table-column prop="positionID" label="岗位编号">
							</el-table-column>
							<el-table-column prop="positionName" label="岗位名称">
							</el-table-column>
							<!-- <el-table-column prop="base" label="工作地点">
							</el-table-column>
							<el-table-column prop="department" label="招聘单位">
							</el-table-column> -->
							<el-table-column prop="updateTime" label="发布时间">
							</el-table-column>
							<el-table-column prop="updateTime" label="发布时间">
							</el-table-column>
							<el-table-column prop="textType" label="岗位状态">
							</el-table-column>
							<el-table-column prop="type" label="岗位类型">
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="resetPosition(scope.row)">修 改
									</el-button>
									<el-button type="text" size="small" @click="offlinePosition(scope.row)"
										v-if="scope.row.positionStatus == 1">下 线
									</el-button>
									<el-button type="text" size="small" @click="uploadPosition(scope.row)"
										v-if="scope.row.positionStatus != 1">发 布
									</el-button>
									<el-button type="text" size="small" @click="deletePosition(scope.row)">删 除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-dialog :visible.sync="dialogPositionInfo">
						<div slot="title" class="selected_title">{{selectedPositionData.type}}</div>
						<el-form :model="selectedPositionData" :rules="rules" ref="ruleForm" label-width="120px"
							class="ruleForm_info">
							<el-form-item label="岗位名称:" prop="name">
								<el-input v-model="selectedPositionData.positionName"></el-input>
							</el-form-item>
							<!-- <el-form-item label="工作地点:" prop="base">
								<el-input v-model="selectedPositionData.base"></el-input>
							</el-form-item>
							<el-form-item label="招聘单位:" prop="department">
								<el-input v-model="selectedPositionData.department"></el-input>
							</el-form-item> -->
							<!-- <el-form-item label="工作职责:" prop="responsibilities">
								<el-input v-model="selectedPositionData.responsibilities" type="textarea"
									:autosize="{ minRows: 3}">
								</el-input>
							</el-form-item> -->
							<el-form-item label="招聘条件:" prop="responsibilities">
								<el-input v-model="selectedPositionData.responsibilities" type="textarea"
									:autosize="{ minRows: 7}">
								</el-input>
							</el-form-item>
							<!-- <el-form-item label="任职资格:" prop="requirements">
								<el-input v-model="selectedPositionData.requirements"></el-input>
							</el-form-item> -->
							<el-form-item label="联系人:" prop="contacts">
								<el-input v-model="selectedPositionData.contact"></el-input>
							</el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button @click="dialogPositionInfo = false">取 消</el-button>
							<el-button type="primary" @click="resetPositionButton()">修 改</el-button>
						</div>
					</el-dialog>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import addControl from "../../components/addControl.vue"
	import {
		loginstatus,
		Logout,
		addAdminUser,
		queryPositionBackend,
		optPosition,
		deletePosition,
	} from '../../api/user.js';
	export default {
		components: {
			addControl,
		},
		data() {
			var validateName = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('岗位名称不能为空！'));
				} else {
					callback();
				}
			};
			var validateBase = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('工作地点不能为空！'));
				} else {
					callback();
				}
			};
			var validateDepartment = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('招聘单位不能为空！'));
				} else {
					callback();
				}
			};
			var validateResponsibilities = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('工作职责不能为空！'));
				} else {
					callback();
				}
			};
			var validateRequirements = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('任职资格不能为空！'));
				} else {
					callback();
				}
			};
			var validateContacts = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('联系人不能为空！'));
				} else {
					callback();
				}
			};
			return {
				addControlDialog: false,
				userID: '',
				showID: '',
				input: '',
				positionData: [],
				selectedPositionData: {},
				dialogPositionInfo: false,
				rules: {
					name: [{
						required: true,
						validator: validateName,
						trigger: 'blur',
					}, ],
					base: [{
						required: true,
						validator: validateBase,
						trigger: 'blur',
					}, ],
					department: [{
						required: true,
						validator: validateDepartment,
						trigger: 'blur',
					}, ],
					responsibilities: [{
						required: true,
						validator: validateResponsibilities,
						trigger: 'blur',
					}, ],
					requirements: [{
						required: true,
						validator: validateRequirements,
						trigger: 'blur',
					}, ],
					contacts: [{
						required: true,
						validator: validateContacts,
						trigger: 'blur',
					}, ],
				},
			};
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 300) {
					let str = res.data;
					this.showID = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userID = res.datadata
				} else {
					this.$message({
						message: '您不具有管理员权限！',
						type: 'error'
					});
					this.$router.push('/')
				}
			});
			queryPositionBackend().then((res) => {
				this.positionData = res.data
				var i = 0
				for (i; i < res.data.length; i++) {
					if (res.data[i].type == 0) {
						this.positionData[i].type = this.positionData[i].type.toString()
						this.positionData[i].type = '校园招聘岗位'
					} else if (res.data[i].type == 1) {
						this.positionData[i].type = this.positionData[i].type.toString()
						this.positionData[i].type = '社会招聘岗位'
					} else if (res.data[i].type == 2) {
						this.positionData[i].type = this.positionData[i].type.toString()
						this.positionData[i].type = '实习生岗位'
					}
					if (res.data[i].positionStatus == 0) {
						this.positionData[i].textType = '暂存'
					} else if (res.data[i].positionStatus == 1) {
						this.positionData[i].textType = '已发布'
					} else if (res.data[i].positionStatus == 2) {
						this.positionData[i].textType = '已下线'
					}
				}
			})
		},
		methods: {
			load() {
				this.count += 2
			},
			offlinePosition(row) {
				optPosition({
					positionStatus: 2,
					contact: row.contact,
					positionName: row.positionName,
					responsibilities: row.responsibilities,
					positionID: row.positionID,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '岗位下线成功！',
							type: 'success'
						});
						location.reload();
					} else {
						this.$message({
							message: '岗位下线失败！',
							type: 'error'
						});
					}
				})
			},
			newStringSet() {
				let newString = ""

				newString = '岗位职责：' + this.ruleForm.responsibilities + '\n'
				newString = newString + '招聘人数：' + this.ruleForm.number + '\n'
				newString = newString + this.ruleForm.requirements

				this.newResponsibilities = newString
			},
			uploadPosition(row) {
				optPosition({
					positionStatus: 1,
					contact: row.contact,
					positionName: row.positionName,
					responsibilities: row.responsibilities,
					positionID: row.positionID,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '岗位发布成功！',
							type: 'success'
						});
						location.reload();
					} else {
						this.$message({
							message: '岗位发布失败！',
							type: 'error'
						});
					}
				})
			},
			deletePosition(row) {
				deletePosition({
					positionID: row.positionID
				}).then((res) => {
					this.$message({
						message: '岗位删除成功！',
						type: 'success'
					});
					location.reload();
				})
			},
			searchPosition() {
				this.positionData = []
				queryPositionBackend({
					name: this.input,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '岗位查询成功！',
							type: 'success'
						});
						this.positionData = res.data
						var i = 0
						for (i; i < res.data.length; i++) {
							if (res.data[i].type == 0) {
								this.positionData[i].type = this.positionData[i].type.toString()
								this.positionData[i].type = '校园招聘岗位'
							} else if (res.data[i].type == 1) {
								this.positionData[i].type = this.positionData[i].type.toString()
								this.positionData[i].type = '社会招聘岗位'
							} else if (res.data[i].type == 2) {
								this.positionData[i].type = this.positionData[i].type.toString()
								this.positionData[i].type = '实习生岗位'
							}
							if (res.data[i].positionStatus == 0) {
								this.positionData[i].textType = '暂存'
							} else if (res.data[i].positionStatus == 1) {
								this.positionData[i].textType = '已发布'
							} else if (res.data[i].positionStatus == 2) {
								this.positionData[i].textType = '已下线'
							}
						}
					} else {
						this.$message({
							message: '岗位查询失败！',
							type: 'error'
						});
					}
				})
			},
			resetPositionButton() {
				optPosition({
					positionStatus: this.selectedPositionData.positionStatus,
					contact: this.selectedPositionData.contact,
					positionName: this.selectedPositionData.positionName,
					responsibilities: this.selectedPositionData.responsibilities,
					positionID: this.selectedPositionData.positionID,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '岗位信息修改成功！',
							type: 'success'
						});
						this.dialogPositionInfo = false;
						location.reload();
					} else {
						this.$message({
							message: '岗位信息修改失败！',
							type: 'error'
						});
					}
				})
			},
			resetPosition(row) {
				this.dialogPositionInfo = true
				this.selectedPositionData = row
			},
			addAdmingAccount(addAdmingAccount) {
				addAdminUser({
					password: addAdmingAccount.adminPassword,
					userID: addAdmingAccount.adminAccount,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '管理员账号添加成功！',
							type: 'success'
						});
						this.addControlDialog = false
					} else {
						this.$message({
							message: '管理员账号添加失败！',
							type: 'error'
						});
						this.addControlDialog = false
					}
				})
			},
			addControl() {
				this.addControlDialog = true
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotoadd() {
				this.$router.push('/management/addPosition')
			},
			// gotoreset(){
			// 	this.$router.push('/management/resetPosition')
			// },
			gotolookupresumeByName() {
				this.$router.push('/management/lookUpResumeByName')
			},
			gotolookupresume() {
				this.$router.push('/management/lookUpResume')
			},
			gotorecruitInfoService() {
				this.$router.push('/management/arcticList')
			},
		},
	};
</script>

<style scoped>
	@import url(../../assets/css/managementcss.css);

	.search_body {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		width: 1150px;
		height: 70px;
		margin-left: 17%;
		background-color: white;
		border-radius: 30px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		padding-top: 14px;
		padding-left: 55px;
	}

	.search_input {
		display: flex;
		width: 90%;
	}

	.search_button {
		background-color: #0056b1;
		width: 100px;
		height: 40px;
		margin-left: 25px;
		border: none;
		cursor: pointer;
	}

	.search_res {
		background-color: white;
		width: 1150px;
		margin-top: 35px;
		margin-left: 17%;
		border-radius: 2px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.selected_title {
		font-size: 20px;
	}

	.ruleForm_info {
		width: 80%;
		margin-left: 5%;
	}
</style>
